import React from 'react';
import { ShoppingCart, CheckCircle, ChevronRight } from 'lucide-react';
import { ABLE_COLORS } from '../../constants';

/**
 * ShoppingCardWidget - Shows shopping list status
 * Priority 3: Planning for shopping trips
 */
export default function ShoppingCardWidget({ 
  shoppingList = [], 
  onNavigate 
}) {
  const itemCount = shoppingList.length;
  const hasItems = itemCount > 0;

  return (
    <button
      onClick={() => onNavigate && onNavigate('shopping')}
      style={{
        width: '100%',
        padding: '20px',
        background: ABLE_COLORS.neutral,
        border: 'none',
        borderRadius: ABLE_COLORS.cardRadius,
        boxShadow: ABLE_COLORS.cardShadow,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        transition: 'all 0.15s ease',
        textAlign: 'left',
      }}
    >
      {/* Icon */}
      <div style={{
        width: '40px',
        height: '40px',
        borderRadius: '10px',
        background: hasItems ? '#DBEAFE' : '#F3F4F6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}>
        {hasItems ? (
          <ShoppingCart size={20} color="#2563EB" />
        ) : (
          <CheckCircle size={20} color={ABLE_COLORS.textMuted} />
        )}
      </div>
      
      {/* Content */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          fontSize: '16px',
          fontWeight: 700,
          color: ABLE_COLORS.textPrimary,
          marginBottom: '4px',
        }}>
          Shopping
        </div>
        <div style={{
          fontSize: '13px',
          fontWeight: 400,
          color: hasItems ? ABLE_COLORS.textSecondary : ABLE_COLORS.textMuted,
        }}>
          {itemCount === 0 ? "List empty" : 
           itemCount === 1 ? "1 item to buy" : 
           `${itemCount} items to buy`}
        </div>
      </div>
      
      {/* Arrow */}
      <ChevronRight size={18} color={ABLE_COLORS.textMuted} style={{ flexShrink: 0 }} />
    </button>
  );
}
